import { defineMessages } from 'react-intl';

export const customerRatingsShowAllMessages = defineMessages({
  showAll: {
    defaultMessage: 'Alle Bewertungen ({ratingCount}) anzeigen',
    id: 'ratings.show-all',
  },
});
